var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function StarFilledIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5703 21.6187C17.7922 22.261 18.9713 21.4055 18.7378 20.0439L17.862 14.9379C17.8705 14.9876 21.559 11.3612 21.559 11.3612C22.5475 10.3976 22.0982 9.01185 20.7311 8.81319L15.6043 8.06823C15.6542 8.07548 13.3451 3.44697 13.3451 3.44697C12.7342 2.20906 11.2774 2.20812 10.666 3.44697L8.37324 8.09256C8.39553 8.04739 3.28001 8.81319 3.28001 8.81319C1.9139 9.0117 1.46284 10.3969 2.45212 11.3612L6.16184 14.9773C6.12577 14.9421 5.2733 20.0439 5.2733 20.0439C5.03994 21.4045 6.21795 22.2615 7.44076 21.6187L12.0262 19.2079C11.9816 19.2314 16.5703 21.6187 16.5703 21.6187Z", fill: "" })));
}
export var StarFilledIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: StarFilledIconInner }, props))); };
//# sourceMappingURL=StarFilledIcon.js.map